/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadImageResponseDto
 */
export interface UploadImageResponseDto {
    /**
     * Success message
     * @type {string}
     * @memberof UploadImageResponseDto
     */
    message: string;
    /**
     * Public URL of uploaded image
     * @type {string}
     * @memberof UploadImageResponseDto
     */
    url: string;
    /**
     * S3 key of uploaded image
     * @type {string}
     * @memberof UploadImageResponseDto
     */
    key: string;
}

/**
 * Check if a given object implements the UploadImageResponseDto interface.
 */
export function instanceOfUploadImageResponseDto(value: object): value is UploadImageResponseDto {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function UploadImageResponseDtoFromJSON(json: any): UploadImageResponseDto {
    return UploadImageResponseDtoFromJSONTyped(json, false);
}

export function UploadImageResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadImageResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'url': json['url'],
        'key': json['key'],
    };
}

export function UploadImageResponseDtoToJSON(value?: UploadImageResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'message': value['message'],
        'url': value['url'],
        'key': value['key'],
    };
}

